"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("../../../../../Types");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var AuthenticationService_1 = require("../../../../../Services/AuthenticationService");
var Util_1 = require("../../../../../Services/Util");
var Components_1 = require("../../../../../Components");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var EventHandlerService_1 = require("../../../../../Services/EventHandlerService");
function AddUserEvent(updateCallback, locations, resources) {
    var _this = this;
    var addUserEventContentRef = React.createRef();
    return new Types_1.VeriLiteInformationEvent(React.createElement(AddUserEventContent, { ref: addUserEventContentRef, updateCallback: updateCallback, locations: locations, resources: resources }), resources.AddUserTitle, [
        new Types_1.VeriLiteEventAction(resources.SetupLocations_AddLocation, "primary", function (currentEvent, closeModalCallback) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                (_a = addUserEventContentRef.current) === null || _a === void 0 ? void 0 : _a.addUser();
                return [2 /*return*/];
            });
        }); }), new Types_1.VeriLiteEventAction(resources.Close, "secondary", function (currentEvent, closeModalCallback) {
            closeModalCallback();
        })
    ]);
}
exports.AddUserEvent = AddUserEvent;
var AddUserEventContentState;
(function (AddUserEventContentState) {
    AddUserEventContentState[AddUserEventContentState["Initial"] = 0] = "Initial";
    AddUserEventContentState[AddUserEventContentState["Pending"] = 1] = "Pending";
    AddUserEventContentState[AddUserEventContentState["Success"] = 2] = "Success";
    AddUserEventContentState[AddUserEventContentState["Error"] = 3] = "Error";
})(AddUserEventContentState || (AddUserEventContentState = {}));
var userRoles = function (resources) { return [{
        key: "User",
        text: resources.User
    }, {
        key: "Administrator",
        text: resources.Administrator
    }]; };
var AddUserEventContent = /** @class */ (function (_super) {
    __extends(AddUserEventContent, _super);
    function AddUserEventContent(props) {
        var _this = _super.call(this, props) || this;
        _this.error = {};
        _this.clearValidation = function () {
            _this.setState({
                UserDataValidation: {
                    AdminDisplayName: _this.state.UserDataValidation.AdminDisplayName.reset(),
                    AdminEmail: _this.state.UserDataValidation.AdminEmail.reset(),
                    DefaultLocation: _this.state.UserDataValidation.DefaultLocation.reset(),
                    UserRole: _this.state.UserDataValidation.UserRole.reset()
                }
            });
        };
        _this.validateInputs = function () {
            var validationData = _this.state.UserDataValidation;
            validationData.AdminDisplayName.validate(_this.state.UserData.AdminDisplayName);
            validationData.AdminEmail.validate(_this.state.UserData.AdminEmail);
            validationData.DefaultLocation.validate(_this.state.UserData.DefaultLocation);
            validationData.UserRole.validate(_this.state.UserData.UserRole);
            _this.setState({ UserDataValidation: validationData });
            return !validationData.AdminDisplayName.isInvalid() && !validationData.AdminEmail.isInvalid() && !validationData.DefaultLocation.isInvalid() && !validationData.UserRole.isInvalid();
        };
        _this.updateUserData = function (event, propName) {
            var _a;
            _this.setState({
                UserData: __assign(__assign({}, _this.state.UserData), (_a = {}, _a[propName] = event.target.value, _a))
            }, function () {
                var _a;
                _this.setState({
                    UserDataValidation: __assign(__assign({}, _this.state.UserDataValidation), (_a = {}, _a[propName] = _this.state.UserDataValidation[propName].validate(_this.state.UserData[propName]), _a))
                });
            });
        };
        _this.updateValidation = function (validationResponse) {
            _this.clearValidation();
            _this.setState({ ApplicationValidation: { Error: validationResponse, State: Types_1.InputValidationState.invalid } });
            //console.log("validationResponse");
            //console.log(validationResponse);
            //if (validationResponse.name == "SetupLocations_CannotAddDuplicateLocations") {
            //    this.setState({
            //        LocationNameValidationError: validationResponse.value,
            //        LocationNameValidationState: InputValidationState.invalid
            //    });
            //}
            //
            //if (validationResponse.name == "SetupLocations_CannotAddDuplicateClientId") {
            //    this.setState({
            //        ClientIdValidationError: validationResponse.value,
            //        ClientIdValidationState: InputValidationState.invalid
            //    });
            //}
        };
        _this.addUser = function () { return __awaiter(_this, void 0, void 0, function () {
            var user, options, json, userRequestHeaders, headers;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.clearValidation();
                        if (!this.validateInputs()) {
                            return [2 /*return*/];
                        }
                        user = this.state.UserData;
                        this.updateModal(AddUserEventContentState.Pending);
                        options = {};
                        options = Object.assign(__assign({}, Util_1.defaultPostOptions), options);
                        json = JSON.stringify(user);
                        options = __assign(__assign({}, options), { body: json });
                        userRequestHeaders = new Util_1.UserRequestHeaders(AuthenticationService_1.Auth.getUser());
                        headers = new Headers(options.headers);
                        return [4 /*yield*/, AuthenticationService_1.Auth.getAccessToken().then(function (token) {
                                headers.append("Authorization", "Bearer " + token);
                                options.headers = headers;
                            }).catch(function (error) {
                                console.error("Error adding auth header: " + error);
                            })];
                    case 1:
                        _a.sent();
                        userRequestHeaders.AppendHeaders(options);
                        fetch("/users/CreateUser", options).then(function (response) {
                            //console.log(response);
                            if (!response.ok) {
                                switch (response.status) {
                                    case 400:
                                        //console.log("400");
                                        _this.updateModal(AddUserEventContentState.Initial);
                                        response.json().then(function (validationResponse) {
                                            _this.updateValidation(validationResponse);
                                        });
                                        break;
                                    case 402:
                                        //console.log("402");
                                        response.json().then(function (errorResponse) {
                                            _this.error.title = errorResponse.title;
                                            _this.error.detail = errorResponse.detail;
                                            _this.updateModal(AddUserEventContentState.Error);
                                        });
                                        break;
                                    case 500:
                                        response.json().then(function (errorResponse) {
                                            _this.error.title = errorResponse.title;
                                            _this.error.detail = errorResponse.detail;
                                            _this.updateModal(AddUserEventContentState.Error);
                                        }).catch(function () {
                                            _this.error.title = _this.props.resources.Error;
                                            _this.error.detail = _this.props.resources.ServerErrorMessage;
                                            _this.updateModal(AddUserEventContentState.Error);
                                        });
                                        break;
                                    default:
                                        response.json().then(function (errorResponse) {
                                            _this.error.title = errorResponse.title;
                                            _this.error.detail = errorResponse.detail;
                                            _this.updateModal(AddUserEventContentState.Error);
                                        }).catch(function () {
                                            _this.error.title = _this.props.resources.Error;
                                            _this.error.detail = _this.props.resources.UnknownErrorMessage;
                                            _this.updateModal(AddUserEventContentState.Error);
                                        });
                                        break;
                                }
                            }
                            else {
                                _this.updateModal(AddUserEventContentState.Success);
                            }
                        }).catch(function (err) {
                            console.error("Error adding new user:");
                            console.error(err);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.updateModal = function (newState) {
            _this.setState({ status: newState });
            switch (newState) {
                case AddUserEventContentState.Success:
                    _this.props.updateCallback();
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.Success;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Finish, "primary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
                case AddUserEventContentState.Error:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.error.title || _this.props.resources.Error;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
                case AddUserEventContentState.Pending:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.LoadingDotDotDot;
                    event.actions = [];
                    eventHandler.UpdateEvent();
                    break;
                case AddUserEventContentState.Initial:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.AddUserTitle;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Add, "primary", function (currentEvent, closeModalCallback) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                this.addUser();
                                return [2 /*return*/];
                            });
                        }); }), new Types_1.VeriLiteEventAction(_this.props.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
            }
        };
        _this.stateBasedRender = function (currentState) {
            switch (currentState) {
                case AddUserEventContentState.Initial:
                    return (React.createElement("div", null,
                        React.createElement(reactstrap_1.InputGroup, { className: "my-3" },
                            React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                                React.createElement(reactstrap_1.InputGroupText, null, _this.props.resources.DisplayName)),
                            React.createElement(reactstrap_1.Input, { valid: _this.state.UserDataValidation.AdminDisplayName.isValid(), invalid: _this.state.UserDataValidation.AdminDisplayName.isInvalid(), onChange: function (e) { return _this.updateUserData(e, "AdminDisplayName"); }, value: _this.state.UserData.AdminDisplayName }),
                            React.createElement(reactstrap_1.FormFeedback, { style: { textAlign: "right" } }, _this.state.UserDataValidation.AdminDisplayName.isInvalid() ? _this.state.UserDataValidation.AdminDisplayName.Validation.Error : "")),
                        React.createElement(reactstrap_1.InputGroup, { className: "my-3" },
                            React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                                React.createElement(reactstrap_1.InputGroupText, null, _this.props.resources.Registration_Email)),
                            React.createElement(reactstrap_1.Input, { valid: _this.state.UserDataValidation.AdminEmail.isValid(), invalid: _this.state.UserDataValidation.AdminEmail.isInvalid(), onChange: function (e) { return _this.updateUserData(e, "AdminEmail"); }, value: _this.state.UserData.AdminEmail }),
                            React.createElement(reactstrap_1.FormFeedback, { style: { textAlign: "right" } }, _this.state.UserDataValidation.AdminEmail.isInvalid() ? _this.state.UserDataValidation.AdminEmail.Validation.Error : "")),
                        React.createElement(reactstrap_1.InputGroup, { className: "my-3" },
                            React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                                React.createElement(reactstrap_1.InputGroupText, null, _this.props.resources.DefaultLocation)),
                            React.createElement(reactstrap_1.Input, { type: "select", valid: _this.state.UserDataValidation.DefaultLocation.isValid(), invalid: _this.state.UserDataValidation.DefaultLocation.isInvalid(), onChange: function (e) { return _this.updateUserData(e, "DefaultLocation"); }, value: _this.state.UserData.DefaultLocation },
                                React.createElement("option", { key: "default", hidden: true }, _this.props.resources.PleaseSelectALocation),
                                _this.props.locations.map(function (location) {
                                    return React.createElement("option", { key: location.Name, value: location.Name }, location.Name);
                                })),
                            React.createElement(reactstrap_1.FormFeedback, { style: { textAlign: "right" } }, _this.state.UserDataValidation.DefaultLocation.isInvalid() ? _this.state.UserDataValidation.DefaultLocation.Validation.Error : "")),
                        React.createElement(reactstrap_1.InputGroup, { className: "my-3" },
                            React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                                React.createElement(reactstrap_1.InputGroupText, null, "Role")),
                            React.createElement(reactstrap_1.Input, { type: "select", valid: _this.state.UserDataValidation.UserRole.isValid(), invalid: _this.state.UserDataValidation.UserRole.isInvalid(), onChange: function (e) { return _this.updateUserData(e, "UserRole"); }, value: _this.state.UserData.UserRole },
                                React.createElement("option", { key: "default", hidden: true }, _this.props.resources.PleaseSelectARole),
                                userRoles(_this.props.resources).map(function (role) {
                                    return React.createElement("option", { key: role.key, value: role.text }, role.text);
                                })),
                            React.createElement(reactstrap_1.FormFeedback, { style: { textAlign: "right" } }, _this.state.UserDataValidation.UserRole.isInvalid() ? _this.state.UserDataValidation.UserRole.Validation.Error : "")),
                        _this.state.ApplicationValidation.isInvalid() && React.createElement(reactstrap_1.FormFeedback, { style: { display: "block" } }, _this.state.ApplicationValidation.Error)));
                case AddUserEventContentState.Pending:
                    return (React.createElement(Components_1.CustomSpinner, null));
                case AddUserEventContentState.Success:
                    return (React.createElement("div", null,
                        React.createElement(reactstrap_1.Row, { className: "text-success mb-2" },
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" },
                                React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "6x", icon: free_solid_svg_icons_1.faCheckCircle })),
                            React.createElement(reactstrap_1.Col, null)),
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" }, _this.props.resources.AddUserSuccessMessage),
                            React.createElement(reactstrap_1.Col, null))));
                case AddUserEventContentState.Error:
                    return (React.createElement("div", null,
                        React.createElement(reactstrap_1.Row, { className: "text-danger mb-2" },
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" },
                                React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "6x", icon: free_solid_svg_icons_1.faTimesCircle })),
                            React.createElement(reactstrap_1.Col, null)),
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" }, _this.error.detail || _this.props.resources.AnErrorHasOccurred),
                            React.createElement(reactstrap_1.Col, null))));
            }
        };
        _this.state = {
            UserData: {},
            UserDataValidation: {
                AdminDisplayName: new Types_1.InputValidation(true, props.resources.InvalidDisplayName, /^\S+.{1,}\S$/),
                AdminEmail: new Types_1.InputValidation(true, props.resources.Registration_Validation_EmailIsNotValid, /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/),
                DefaultLocation: new Types_1.InputValidation(),
                UserRole: new Types_1.InputValidation()
            },
            status: AddUserEventContentState.Initial,
            ApplicationValidation: new Types_1.Validation()
        };
        return _this;
    }
    AddUserEventContent.prototype.render = function () {
        return this.stateBasedRender(this.state.status);
    };
    return AddUserEventContent;
}(React.Component));
//# sourceMappingURL=AddUserEvent.js.map